// @flow

import * as React from 'react'
import LinkifyIt from 'linkify-it'
import tlds from 'tlds'

// code lifted from https://github.com/tasti/react-linkify

const defaultComponentDecorator = (decoratedHref: string, decoratedText: string, key: number): React.Node => {
  return (
    <a href={decoratedHref} key={key}>
      {decoratedText}
    </a>
  )
}

const defaultHrefDecorator = (href: string): string => {
  return href
}

const defaultMatchDecorator = (text: string): Array<Object> => {
  const linkify = new LinkifyIt()
  linkify.tlds(tlds)
  return linkify.match(text)
}
const defaultTextDecorator = (text: string): string => {
  return text
}

type PropsType = {
  children: React.Node,
  componentDecorator: (string, string, number) => React.Node,
  hrefDecorator: (string) => string,
  matchDecorator: (string) => Array<Object>,
  textDecorator: (string) => string
}

class Linkify extends React.Component<PropsType, {}> {
  static defaultProps = {
    componentDecorator: defaultComponentDecorator,
    hrefDecorator: defaultHrefDecorator,
    matchDecorator: defaultMatchDecorator,
    textDecorator: defaultTextDecorator
  }

  parseString (string: string): any {
    if (string === '') {
      return string
    }

    const matches = this.props.matchDecorator(string)
    if (!matches) {
      return string
    }

    const elements = []
    let lastIndex = 0
    matches.forEach((match: any, i: number): void => {
      // Push preceding text if there is any
      if (match.index > lastIndex) {
        elements.push(string.substring(lastIndex, match.index))
      }

      const decoratedHref = this.props.hrefDecorator(match.url)
      const decoratedText = this.props.textDecorator(match.text)
      const decoratedComponent = this.props.componentDecorator(decoratedHref, decoratedText, i)
      elements.push(decoratedComponent)

      lastIndex = match.lastIndex
    })

    // Push remaining text if there is any
    if (string.length > lastIndex) {
      elements.push(string.substring(lastIndex))
    }

    return (elements.length === 1) ? elements[0] : elements
  }

  parse (children: any, key: number = 0): any {
    if (typeof children === 'string') {
      return this.parseString(children)
    } else if (React.isValidElement(children) && (children.type !== 'a') && (children.type !== 'button')) {
      return React.cloneElement(children, { key }, this.parse(children.props.children))
    } else if (Array.isArray(children)) {
      return children.map((child: any, i: number): any => this.parse(child, i))
    }

    return children
  }

  render (): React.Node {
    return (
      <React.Fragment>
        {this.parse(this.props.children)}
      </React.Fragment>
    )
  }
}

export default Linkify
